module.exports = __webpack_public_path__ + "img/gwyx-lcsw.85871be6.png";